<template>
  <div>
    <textarea
      ref="textArea"
      v-model="message"
      placeholder="Escribe un mensaje..."
      style="overflow-y: hidden; resize: none;"
    ></textarea>
    <button @click="toggleRecord">
      {{ isRecording ? 'Detener' : 'Grabar' }}
    </button>
    <p v-if="error">{{ error }}</p>
  </div>
</template>

<script>
/* global webkitSpeechRecognition */
/* global SpeechRecognition */
export default {
  props: {
    modelValue: {
      type: String,
      default: "",
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      message: "",
      isRecording: false,
      recognition: null,
      error: null,
      finalTranscript: "",
      interimTranscript: "",
    };
  },
  mounted() {
    this.setupSpeechRecognition();
     this.adjustTextareaHeight();
     this.message = this.modelValue;
  },
  watch: {
    message(newValue) {
      this.$emit("update:modelValue", newValue);
       this.adjustTextareaHeight();
    },
    modelValue(newValue) {
        this.message = newValue;
        this.adjustTextareaHeight()
    }
  },
  beforeUnmount() {
    if (this.recognition) {
      this.recognition.abort();
    }
  },
  methods: {
    setupSpeechRecognition() {
      if ("webkitSpeechRecognition" in window) {
        this.recognition = new webkitSpeechRecognition();
      } else if ("SpeechRecognition" in window) {
        this.recognition = new SpeechRecognition();
      } else {
        this.error =
          "La API de Reconocimiento de Voz no es compatible con este navegador.";
        return;
      }

      this.recognition.continuous = true;
      this.recognition.interimResults = true;
      this.recognition.lang = "es-ES";

      this.recognition.onstart = () => {
        this.isRecording = true;
        this.error = null;
      };

      this.recognition.onend = () => {
        this.isRecording = false;
      };

      this.recognition.onresult = (event) => {
           let currentInterim = "";
           let currentFinal = "";

           for(let i = event.resultIndex; i < event.results.length; i++) {
             const result = event.results[i]
             if (result.isFinal) {
                currentFinal += result[0].transcript;
             } else {
              currentInterim += result[0].transcript;
             }
           }
        if (currentFinal) {
           this.finalTranscript += currentFinal;
        }
           this.interimTranscript = currentInterim;
           this.message = (this.finalTranscript + " " + this.interimTranscript).trim();
      };

      this.recognition.onerror = (event) => {
        this.error = `Error de reconocimiento de voz: ${event.error}`;
        this.isRecording = false;
      };
    },
    toggleRecord() {
      if (!this.recognition) return;
      if (this.isRecording) {
        this.recognition.stop();
      } else {
         this.finalTranscript = "";
         this.interimTranscript = "";
         this.message = "";
        this.recognition.start();
      }
    },
    adjustTextareaHeight() {
        this.$nextTick(() => {
             const textarea = this.$refs.textArea;
            if (textarea) {
                textarea.style.height = 'auto';
                textarea.style.height =  textarea.scrollHeight + 'px';
            }
        })
    }
  },
};
</script>